/**
 * Composable pro práci s Google Tag Manager
 */
export function useGTM() {
  const { proxy } = useScriptGoogleTagManager()

  /**
   * Odeslání vlastní události do GTM
   */
  const trackEvent = (eventName: string, eventData?: Record<string, unknown>) => {
    proxy.dataLayer.push({
      event: eventName,
      ...eventData
    })
  }

  /**
   * Sledování stránky
   */
  const trackPageView = (title?: string, path?: string) => {
    const route = useRoute()
    proxy.dataLayer.push({
      event: 'pageview',
      page_title: title || document.title,
      page_path: path || route.path,
      page_url: window.location.href
    })
  }

  /**
   * Sledování konverze
   */
  const trackConversion = (value?: number, currency = 'CZK') => {
    proxy.dataLayer.push({
      event: 'conversion',
      value,
      currency
    })
  }

  /**
   * Sledování registrace
   */
  const trackRegistration = (method?: string) => {
    proxy.dataLayer.push({
      event: 'sign_up',
      method: method || 'email'
    })
  }

  /**
   * Sledování přihlášení
   */
  const trackLogin = (method?: string) => {
    proxy.dataLayer.push({
      event: 'login',
      method: method || 'email'
    })
  }

  /**
   * Sledování stažení souboru
   */
  const trackDownload = (fileName: string, fileType?: string, fileSize?: number) => {
    proxy.dataLayer.push({
      event: 'file_download',
      file_name: fileName,
      file_type: fileType,
      file_size: fileSize
    })
  }

  /**
   * Sledování formuláře
   */
  const trackFormSubmit = (formName: string, formData?: Record<string, unknown>) => {
    proxy.dataLayer.push({
      event: 'form_submit',
      form_name: formName,
      ...formData
    })
  }

  /**
   * Sledování vyhledávání
   */
  const trackSearch = (searchTerm: string, searchResults?: number) => {
    proxy.dataLayer.push({
      event: 'search',
      search_term: searchTerm,
      search_results: searchResults
    })
  }

  /**
   * Sledování engagement
   */
  const trackEngagement = (engagementType: string, value?: number) => {
    proxy.dataLayer.push({
      event: 'engagement',
      engagement_type: engagementType,
      engagement_value: value
    })
  }

  /**
   * Sledování chyb
   */
  const trackError = (errorType: string, errorMessage: string) => {
    proxy.dataLayer.push({
      event: 'error',
      error_type: errorType,
      error_message: errorMessage
    })
  }

  /**
   * Sledování času na stránce
   */
  const trackTimeOnPage = (timeSeconds: number, pagePath: string) => {
    proxy.dataLayer.push({
      event: 'time_on_page',
      time_seconds: timeSeconds,
      page_path: pagePath
    })
  }

  /**
   * Sledování scroll depth
   */
  const trackScrollDepth = (depth: number, pagePath: string) => {
    proxy.dataLayer.push({
      event: 'scroll_depth',
      scroll_depth: depth,
      page_path: pagePath
    })
  }

  return {
    trackEvent,
    trackPageView,
    trackConversion,
    trackRegistration,
    trackLogin,
    trackDownload,
    trackFormSubmit,
    trackSearch,
    trackEngagement,
    trackError,
    trackTimeOnPage,
    trackScrollDepth,
    dataLayer: proxy.dataLayer
  }
}
